export default "__VITE_ASSET__446df78e__"